export default __webpack_public_path__ + "static/media/book5.4135fe63.jpeg";